import React, { useState, useEffect, useContext, Component } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'; // Import SweetAlert2

import AccountSidebar from '../../components/AccountSidebar';
import { toast } from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { authActions } from '../../../redux/store';
import axios from 'axios';
import axiosInstance, { weburl } from '../../../axiosInstance';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import withReactContent from 'sweetalert2-react-content'; // Import React components for SweetAlert2
import { useBlogContext } from '../../../fetchdata/BlogContext';


import { Helmet } from 'react-helmet';
import getCookie from '../../../helper/getCookie';
import getDecryptData from '../../../helper/getDecryptData';
import HeaderPage from '../../components/HeaderPage';
const MySwal = withReactContent(Swal); // Create a SweetAlert2 instance with React components

const Account = () => {
  const { Headers, isHeader } = useBlogContext();

  const decryptdatajson = getDecryptData();


  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const isLoginFromLocalStorage = localStorage.getItem('token') ? true : false;
  const isLoginFromLocalStorage = getCookie('token') ? true : false;

  const [isLogin, setIsLogin] = useState(isLoginFromLocalStorage);

  const [isLoginForm, setIsLoginForm] = useState(true); // State to manage which form to display

  const [IfLogin, setIfLogin] = useState(true); // State to manage which form to display



  const toggleForm = () => {
    setIsLoginForm(prevState => !prevState); // Toggle between login and signup forms
  };


  useEffect(() => {
    // console.log(isLoginFromLocalStorage, 'isLoginFromLocalStorage')

    const checkUserToken = async () => {
      console.log('Effect is running');
      // Check if this is printed multiple times

      // const usertoken = localStorage.getItem('token');

      const usertoken = getCookie('token');

      if (!usertoken) {
        toast.error("Please Login First");
        navigate('/');

      }

    }
    checkUserToken();
  }, [dispatch, navigate]);

  const [platform, setPlatform] = useState(null);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      setPlatform('Android');
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setPlatform('iOS');
    } else {
      setPlatform('Web');
    }
  }, []);


  const [Order, setOrder] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [OrderPlace, setOrderPlace] = useState('');
  const [MYuser, setMYuser] = useState('');
  const [formData, setFormData] = useState([]);


  // const userId = localStorage.getItem('userId');
  const userId = getCookie('userId');

  const getUserOrders = async () => {

    try {

      const id = decryptdatajson?._id;

      const { data } = await axiosInstance.get(`/user-orders/${id}`);
      // console.log(id);
      if (data?.success) {
        setOrder(data?.userOrder.orders);
        setOrderPlace(data?.userOrder.orders.length)
      }
      setIsLoading(false); // Set loading state to false after fetching data
      setIfLogin(false)
    } catch (error) {
      console.log(error);
      setIsLoading(false); // Set loading state to false in case of an error

    }
  };

  useEffect(() => {
    // This useEffect runs whenever the 'blog' state variable changes
    // console.log(Order); // Log the updated 'blog' state
  }, [Order]); // Dependency array with 'blog' ensures the effect runs when 'blog' state changes


  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);


  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  }


  useEffect(() => {


    getUserOrders();
  }, []); // Empty dependency array ensures that the effect runs once after the initial render


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));

  };



  // Function to handle delete
  const handleCancelOrder = (categoryId) => {
    if (!formData.comment || formData.comment === '') {
      toast.error('Comment is required');
      return null;
    }

    const mycomment = `Cancelled by user: ${formData.comment}`;

    MySwal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this data!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Cancel it!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true,
      customClass: {
        popup: 'custom-swal-popup', // Add a class to the entire dialog
        confirmButton: 'btn-primary', // Add a class to the confirm button
      },
    }).then((result) => {
      if (result.isConfirmed) {

        axiosInstance.put(`/cancel-order/${categoryId}`, { comment: mycomment })
          .then(() => {
            // Refresh the data or update the state after successful deletion
            getUserOrders();
            toast.success("Cancel Order Successfully!");
            setFormData([]);

          })
          .catch((error) => {
            console.error('Error Mark Done:', error);
            toast.error("Error Cancel Order");

          });
      }
    });
  };


  const [submitLoading, setSubmitLoading] = useState(false);


  const handleSubmit = async (order_id, total) => {


    // Start loading before the submission process
    setSubmitLoading(false);

    // Prepare data for submission
    const updatedFormData = {
      orderId: order_id,
      totalAmount: Math.round(total),  // Round the value of total / 2
    };

    try {


      // Send the data to the backend

      const data = await axiosInstance.post(`/order-payment`, updatedFormData);

      console.log('dataaa', data)
      const { success, Order } = data.data;
      if (success) {

        console.log('buyPlan', Order)
        const options = {
          key: Headers.keyId,
          amount: Math.round(total * 100),
          currency: "INR",
          name: Headers?.meta_title || 'unknown',
          description: Headers?.meta_description || 'unknown',
          image: Headers.meta_logo,
          order_id: Order.razorpay_order_id,
          callback_url: `${weburl}order-payment-verification`,
          // prefill: {
          //   name: "test gupta",
          //   email: "test@gmail.com",
          //   contact: "1234567890",
          // },
          notes: {
            address: "razorapy official",
          },
          theme: {
            color: "#3399cc",
          },
        };
        const razor = new window.Razorpay(options);
        razor.open();


      } else {
        toast.error(data.message || "Something went wrong. Please try again.");
      }



    } catch (error) {
      console.error("Error On payment:", error);
    } finally {
      // Stop loading after the submission process finishes
      setSubmitLoading(true);
    }


  };


  return (
    <>

      <Header />

      <HeaderPage title={'All Order'} />

      <main className="page-content bg-light mypadding overflow-auto pb-4 px-0" >

        <div className='px-3'>

          <div className=" my-1">
            <div id="main-content " >


              <div className='container'>
                <div className="row" >
                  {isLoading ? (
                    // Display loading skeletons while data is being fetched
                    Array.from({ length: 4 }).map((_, index) => (

                      <div className="col-md-6 mb-2" key={index}>
                        <div className="card my-3 shadow-sm">
                          <div className="card-body">

                            {/* Top Row - Order ID and Mode */}
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <div className="skeleton w-50" style={{ height: 14, borderRadius: 2 }} />
                              <div className="skeleton w-25" style={{ height: 14, borderRadius: 2 }} />
                            </div>

                            {/* OTP and Date */}
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <div className="skeleton w-50" style={{ height: 14, borderRadius: 2 }} />
                              <div className="skeleton w-25" style={{ height: 14, borderRadius: 2 }} />
                            </div>

                            {/* Status */}
                            <div className="skeleton w-75 mb-3" style={{ height: 14, borderRadius: 2 }} />

                            {/* Progress Bar */}
                            <div className="progress mb-3" style={{ height: '6px' }}>
                              <div className="progress-bar bg-light" style={{ width: '100%' }} />
                            </div>


                            {/* Buttons */}
                            <div className="d-grid gap-2">
                              <div className="skeleton w-100" style={{ height: 32, borderRadius: 4 }} />
                              <div className="skeleton w-100" style={{ height: 32, borderRadius: 4 }} />
                            </div>
                          </div>
                        </div>
                      </div>

                    ))
                  ) : <>

                    {Order.length === 0 && <>
                      <div className="text-center mt-5 mb-4">

                        <img src="/assets/img/product-not-found.png" alt='no cart' style={{ maxWidth: 200 }} />
                        <p className="h3" style={{ fontWeight: 300 }} > No order found </p>
                        <Link className="btn btn-primary btn-shadow d-block w-50 mt-4 mx-auto" to="/">Shop Now</Link>

                      </div> </>}

                    {Order.map(Order => (
                      <>


                        <div className="card my-3 shadow-sm col-md-6 mb-2">
                          <div className="card-body">

                            {/* Order ID & OTP */}
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <h6 className="card-title text-uppercase mb-0">Order #{Order.orderId}</h6>
                              <span className="badge bg-primary text-uppercase">
                                {Order.mode}
                              </span>
                            </div>



                            {/* OTP & Date */}
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              {Order.status === 7 && (
                                <span className="badge bg-info text-dark text-uppercase">
                                  OTP: {Order?.OTP ? Order?.OTP : "NA"}
                                </span>
                              )}
                              <small className="text-muted">{formatDate(Order.createdAt)}</small>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mb-2">

                              {/* Status */}
                              <div className="mb-3">
                                <span className="fw-semibold">Status: </span>
                                <span className="text-dark">
                                  {Order?.items && Order?.items[0]?.id === '1' ?
                                    (
                                      // Status mapping for id === 1
                                      <>
                                        {Order.status === 0 && 'Cancelled'}
                                        {Order.status === 1 && 'Pending'}
                                        {Order.status === 2 && 'Final Price'}
                                        {Order.status === 3 && 'Placed'}
                                        {Order.status === 4 && 'Confirmed'}
                                        {Order.status === 5 && 'Processing'}
                                        {Order.status === 6 && 'Started'}
                                        {Order.status === 7 && 'Ready For Pickup'}
                                        {Order.status === 8 && 'Completed'}

                                        {![0, 1, 2, 3, 4, 5, 6, 7, 8].includes(Order.status) && 'Unknown'}
                                      </>
                                    ) : (
                                      // Status mapping for other ids
                                      <>
                                        {Order.status === 0 && 'Cancelled'}
                                        {Order.status === 1 && 'Placed'}
                                        {Order.status === 2 && 'Accepted'}
                                        {Order.status === 3 && 'Confirmed'}
                                        {Order.status === 4 && 'Processing'}
                                        {Order.status === 5 && 'Started'}
                                        {Order.status === 6 && 'Shipped'}
                                        {Order.status === 7 && 'Ready For Pickup'}
                                        {Order.status === 8 && 'Completed'}

                                        {![0, 1, 2, 3, 4, 5, 6, 7, 8].includes(Order.status) && 'Unknown'}
                                      </>
                                    )}

                                </span>
                              </div>

                              <div className="mb-3">
                                <span className="fw-semibold">Payment: </span>
                                <span className={` ${Order.payment === 0 ? 'text-danger' : Order.payment === 1 ? 'text-success' : 'text-warning'}`}>
                                  {
                                    Order.payment === 0 ? 'unpaid' :
                                      Order.payment === 1 ? 'Full Paid' :
                                        Order.payment === 3 ? 'Partially Paid' :
                                          'failed'
                                  }
                                </span>
                              </div>


                            </div>

                            {/* Progress Bar */}
                            <div className="progress mb-3" style={{ height: '6px' }}>
                              <div
                                className="progress-bar bg-success"
                                role="progressbar"
                                style={{ width: `${(parseInt(Order.status) / 8) * 100}%` }}
                              ></div>
                            </div>


                            {/* Buttons Section */}
                            <div className="d-grid gap-2">

                              {/* Live Button */}
                              {(Order.status !== 0 && Order.status !== 7 && Headers?.ios && Headers?.android) && (
                                <button
                                  type="button"
                                  className="btn btn-success btn-sm d-none text-white"
                                  data-bs-toggle="modal"
                                  data-bs-target="#exampleModal"
                                >
                                  Live <i className="ri-radio-button-line text-white ms-1" />
                                </button>
                              )}

                              {/* Cancel Order */}
                              {(Order.status === 1 || Order.status === 2) && (
                                <div className="dropdown">
                                  <button
                                    className="btn btn-danger btn-sm dropdown-toggle w-100"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    Cancel Order
                                  </button>
                                  <ul className="dropdown-menu border  border-dark border-2 rounded shadow bg-light  w-100 p-2">
                                    <div className="bg-light p-2 rounded">
                                      <label htmlFor="comment">
                                        Comment <span className="text-danger">(required)</span>
                                      </label>
                                      <textarea
                                        id="comment"
                                        className="form-control"
                                        name="comment"
                                        value={formData.comment}
                                        onChange={handleChange}
                                      />
                                      <button
                                        className="btn btn-dark btn-sm mt-2 w-100"
                                        onClick={() => handleCancelOrder(Order?._id)}
                                      >
                                        Submit
                                      </button>
                                    </div>
                                  </ul>
                                </div>
                              )}



                              <div className="dropdown">
                                {(Order.payment !== 3 && Order?.items && Order?.items[0]?.id === '1' && Order.status === 2 && Order.paid !== Order.totalAmount) && <>
                                  <button
                                    className="btn btn-primary btn-sm text-white w-100 text-uppercase"
                                    type='button'
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    Pay Now
                                  </button>

                                  <ul className="dropdown-menu border  border-dark border-2 rounded shadow bg-light  w-100 p-2">
                                    <div className="bg-light p-2 rounded">
                                      <p className='text-center mb-1'>  <i className="ri-arrow-down-wide-line fw-bold h3 " /> </p>


                                      <button
                                        className="btn btn-dark btn-sm text-white w-100 text-uppercase mb-4"
                                        type='button'
                                        onClick={() => handleSubmit(Order._id, (Order.totalAmount / 2))}
                                      >
                                        Pay Half
                                      </button>

                                      <button
                                        className="btn btn-dark btn-sm text-white w-100 text-uppercase  mb-4"
                                        type='button'
                                        onClick={() => handleSubmit(Order._id, Order.totalAmount)}
                                      >
                                        Pay Full
                                      </button>
                                      <p className='text-center'> OR </p>
                                      <label className='mb-2' for="price">Custom Price</label>
                                      <div className='d-flex gap-2'>
                                        <input
                                          id="price"
                                          className="form-control form-control-sm m-0"
                                          name="price"
                                          value={formData.price}
                                          onChange={handleChange}
                                          placeholder='Enter Amount'
                                        />
                                        <button
                                          className="btn btn-dark btn-sm w-auto"
                                          onClick={() => {
                                            if (formData.price < (Order.totalAmount / 2)) {
                                              toast.error('You can not pay less then 50%');
                                              return
                                            }
                                            handleSubmit(Order._id, formData.price)
                                          }}
                                        >
                                          Pay
                                        </button>
                                      </div>




                                    </div>
                                  </ul>

                                </>}


                                {(Order.payment !== 1 && Order?.items && Order?.items[0]?.id === '1' && (Order.status === 7 || Order.status === 6)) && <>
                                  {Order.totalAmount !== Order.paid &&
                                    <button
                                      className="btn btn-dark btn-sm text-white w-100 text-uppercase"
                                      onClick={() => handleSubmit(Order._id, (Order.totalAmount - Order.paid))}
                                    >
                                      Pay Final
                                    </button>

                                  }
                                </>}




                              </div>

                              {/* Order Info Link */}
                              <Link
                                className="btn btn-primary btn-sm text-white text-uppercase w-100"
                                to={`/account/order/${decryptdatajson._id}/${Order._id}`}
                              >
                                Order Info
                              </Link>
                            </div>
                          </div>
                        </div >




                      </>
                    ))
                    }

                  </>
                  }
                </div>
              </div>




            </div>
          </div>

        </div>
      </main >

      <Footer />



    </>
  )
}

export default Account